import React from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import SimpleMantenedorLayout from '../../../components/SimpleMantenedorLayout';
import { useMantenedores } from '../../../context/MantenedoresContext';
import { useGeneralesCrud } from '../../../hooks/useGeneralesCrud';
import { GeneralesTable } from '../../../components/Generales';
import { GeneralesModal } from '../../../components/Generales';

const ServicioSpread = () => {
  const history = useHistory();
  const user = useSelector(state => state.auth.user);
  const { userPermissions } = useMantenedores();
  const permisos = userPermissions?.modules?.generales || {};

  // Hook para gestionar CRUD
  const crudHook = useGeneralesCrud('servicio-spread', user, permisos);

  // Navegar atrÃ¡s
  const handleGoBack = () => {
    history.push('/mantenedores/generales');
  };

  return (
    <SimpleMantenedorLayout
      mantenedorId="generales"
      title="Servicio Spread"
      subtitle="Gestión de servicios de Spread"
      iconColor="#3f51b5"
      breadcrumbs={[
        { label: 'Generales', path: '/mantenedores/generales' },
        { label: 'Servicio Spread' }
      ]}
      showBackButton={false}
      onBackClick={handleGoBack}
    >
      {!permisos.canView ? (
        <Row>
          <Col xs={12}>
            <div className="text-center mt-4">
              <h5>No tienes permisos para ver esta sección</h5>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col xs={12}>
            {crudHook.error && (
              <div className="alert alert-danger" role="alert">
                {crudHook.error}
              </div>
            )}
            
            <GeneralesTable
              data={crudHook.data}
              loading={crudHook.loading}
              total={crudHook.total}
              pageSize={crudHook.pageSize}
              pageNumber={crudHook.pageNumber}
              totalPages={crudHook.totalPages}
              onPageChange={crudHook.handlePageChange}
              onPageSizeChange={crudHook.handlePageSizeChange}
              onRowClick={crudHook.handleEdit}
              searchValue={crudHook.searchValue}
              onSearch={crudHook.handleSearch}
              columnas={crudHook.columnas}
              title="Servicio Spread"
              onCreateClick={crudHook.handleCreate}
              permisos={permisos}
              sortConfig={crudHook.sortConfig}
              onSort={crudHook.onSort}
              filters={crudHook.filters}
              onFilterChange={crudHook.onFilterChange}
              getUniqueValues={crudHook.getUniqueValues}
            />

            <GeneralesModal
              show={crudHook.showModal}
              mode={crudHook.modalMode}
              item={crudHook.selectedElement}
              campos={crudHook.campos}
              formData={crudHook.formData}
              formErrors={crudHook.formErrors}
              onFormChange={crudHook.onFormChange}
              onHide={crudHook.closeModal}
              onSubmit={crudHook.handleSave}
              submitting={crudHook.savingElement}
              permisos={permisos}
              dependentData={crudHook.dependentData}
            />
          </Col>
        </Row>
      )}
    </SimpleMantenedorLayout>
  );
};

export default ServicioSpread;
